export enum Locale {
  NL_BE = 'nl-BE',
  FR_BE = 'fr-BE',
  DE_DE = 'de-DE',
  EN_GB = 'en-GB',
}
